export default __webpack_public_path__ + "static/media/home.768537f6.jpeg";